<template>
	<div id="app">
		<div v-if="$route.path.indexOf('mh5') > -1">
			<router-view />
			<van-tabbar v-if="judgePcOrAndirodCopy()" v-model="active" active-color="#409eff" @change="changePage()"
				inactive-color="#000">
				<van-tabbar-item icon="wap-home-o">{{ $t('aside.home') }}</van-tabbar-item>
				<!-- <van-tabbar-item icon="bag-o">{{$t('other.a340')}}</van-tabbar-item> -->
				<van-tabbar-item icon="contact">{{ $t('homeTwo.Personalcenter') }}</van-tabbar-item>
			</van-tabbar>
		</div>
		<div v-else>
			<Header v-if="initShow
				|| path == '/addNewGoods'
				|| path == '/publishTikTok'
				|| path == '/imageEdit'
				|| path == '/watermark'
				|| path == '/addGoods'
				|| path == '/purchuseList'
				|| path == '/publishLazada'
				|| path == '/publishShopee'
				|| path == '/scanPrint'
				|| path == '/precistDelivery'
				|| path == '/package'
				|| path == '/scanIntoStoreage'
				|| path == '/processedDetail'
				|| path == '/tiktokShop'
				|| path == '/massPublishTikTok'

			" />
			<div class="main">
				<!-- <Aside v-show="ttbv() "  v-if="initShow " /> -->
				<AsideTab v-show="ttbv()" v-if="initShow && isRouterAlive"></AsideTab>
				<div :class="{ 'tipbf': isCollapse == false && ttbv(), 'kvbn': isCollapse && ttbv(), 'bkjm': $route.meta.showHeaderAside }"
					style="width:100%">
					<keep-alive>
						<router-view v-if="$route.meta.keepAlive" />
					</keep-alive>
					<router-view v-if="!$route.meta.keepAlive" />
				</div>
			</div>
			<!-- <div v-if="hideChat" class="service-body" @click="todischat" v-show="!(path == '/servicechat' || path == '/iddstation')" id="carMessage" @mousedown='draggableFun($event)'>
			<div><img src="./assets/img/ss1.png" alt="" style="width:40px;height:40px"></div>
			<div class="ser-div">
			<el-badge :value="valnum" class="item"  :hidden="valchcke">
			</el-badge></div>
		</div> -->
		</div>
		<el-dialog :visible.sync="dialogVisible" width="70%" :before-close="handleClose">
			<DisChat></DisChat>
		</el-dialog>

	</div>
</template>

<script>
import Header from './pages/header/header.vue'
import Aside from './pages/aside/aside.vue'
import AsideTab from './pages/aside/asideTab.vue'
import BackTop from './components/BackTop'
import api from './api/moudles/shopaccess'
import customerChat from './components/customerChat'
import loginPage from './components/customerChat'
import { mapState, mapActions, mapMutations } from 'vuex'
import utils from './utils/utils'
import DisChat from './pages/userstoreitems/distribution/districhat.vue'

export default {
	name: 'app',
	components: {
		Header,
		Aside,
		AsideTab,
		BackTop,
		customerChat,
		DisChat,
		loginPage,
		list: [1, 2, 32]

	},
	provide() {
		return {
			reload: this.reload
		}
	},
	data() {
		return {
			timer: '',
			valchcke: false,
			userId: '',
			valnum: null,
			dialogVisible: false,
			servie: false,
			path: '',
			showTrue: false,
			isRouterAlive: true,
			initShow: false,
			active: 0,
			cashViews: ['index'],
			hideAside: [
				'/scanBarCode',
				'/addNewGoods',
				'/signOrder',
				'/publishTikTok',
				'/stockingList',
				'/registorpage',
				'/shopifyAuthorzation',
				'/privacystatement',
				'/registor',
				'/massPublishTikTok',
				'/sealpage',
				'/newPage',
				'/orderpage',
				'/printpage',
				'/loginPage',
				'/watermark',
				'/pickinglist',
				'/personal',
				'/publishLazada',
				'/publishShopee',
				'/personal-account',
				'/personal-address',
				'/personal-info',
				'/addGoods',
				'/distributionLog',
				'/processedDetail',
				'/scanPrint',
				'/package',
				'/promotional',
				'/barCode',
				'/getOrderDeduction',
				'/lazadaDefualtPicklist',
				'/newPagePicklist',
				'/orderAndpicklist',
				'/loginToken',
				'/purchaseBarcode',
				'/productPicklist',
				'/pickinglistCopy',
				'/productStockling',
				'/productAndPicklist',
				'/lazadaStockList',
				'/imageEdit',
				'/precistDelivery',
				'/privacy',
				'/scanIntoStoreage',
				'/inventory',
				'/productAndPicklistCopy',
				'/userRegistor',
				'/iddstation',
				'/remoteDXSaccount',
				'/Detail',
				'/loginDetail',
				'/loginRmote',
				'/login',
				'/purchuseList',
				'/tiktokShop',
				'/welcome',
				'/'


			],
			hideChatList: [
				'/loginDetail',
				'/loginPage',
				'/package'
			],
			hideChat: false,
		}
	},
	watch: {
		$route(to, from) {
			this.path = to.path
			if (from.path == '/stockProduct/productDetail' && to.path == '/stockProduct/single') {
				localStorage.setItem('setPage', 1)
			}
			if (this.hideAside.includes(this.path)) {
				this.initShow = false
			} else {
				this.initShow = true
			}

			if (this.hideChatList.includes(this.path)) {
				this.hideChat = false
			} else {
				this.hideChat = true
			}


		},


	},
	computed: {
		...mapState({
			isCollapse: state => state.common.isCollapse,
		}),
	},
	created() {
		this.getUserDetail()
		this.getunread();
		this.userId = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).userId : null
		// 实现轮询
		console.log(window.location.search, 'window.location.search')
		this.switchLang()


	},
	mounted() {
		console.log(this.userId);
		// this.timer = setInterval(this.getunread, 20000);

		// 实现轮询

		window.setInterval(() => {
			setTimeout(this.getunread(), 0);

		}, 30000);


		this.checkVersion();
	},

	methods: {
		...mapMutations('shopaccess', [
			'SET_STORAGE_TTP',
			'GET_LAZADA_SHOP',
			'DELET_HAS_CLAIM_ALL'

		]),

		...mapActions('shopaccess', [
			'checkPartner'
		]),

		...mapMutations('login', [
			'SWITCH_LANG',
		]),
		hasLangParam() {
			const urlParams = new URLSearchParams(window.location.search);
			return urlParams.has('lang');
		},
		switchLang() {
			// 获取URL的查询字符串部分
			const queryString = window.location.search;

			// 使用URLSearchParams解析查询字符串
			const urlParams = new URLSearchParams(queryString);

			// 获取'lang'参数的值
			const lang = urlParams.get('lang');

			// 检查'lang'参数是否存在，并获取其值
			if (lang !== null) {
				console.log('lang参数存在，其值为:', lang);
				this.SWITCH_LANG(lang)
				this.$i18n.locale = lang
			} else {
				console.log('lang参数不存在');
			}
		},

		checkVersion() {
			const lastVersion = localStorage.getItem('appVersion');
			const currentVersion = process.env.VUE_APP_VERSION || '1.0.7';

			if (lastVersion !== currentVersion) {
				localStorage.setItem('appVersion', currentVersion);
				window.location.reload(true); // 强制刷新
			}
		},

		getunread() {
			if (localStorage.getItem('userInfo')) {
				api
					.getunreadconunt({
						userId: JSON.parse(localStorage.getItem('userInfo')).userId
					})
					.then((res) => {
						if (res.userUnreadCount == 0) {
							this.valchcke = true
						} else {
							this.valnum = res.userUnreadCount;
						}
					});

			}
		},
		judgePcOrAndirodCopy() {
			return utils.judgePcOrAndirod()
		},
		todischat() {
			// this.$router.push('/districhat')
			// this.dialogVisible = true;
			if (this.dialogVisible == true) {
				this.dialogVisible = false
			} else {
				this.dialogVisible = true
			}
		},
		handleClose() {
			this.dialogVisible = false;
			this.getunread();//刷新未读数
		},
		draggableFun(val) {
			var div = document.getElementById("carMessage");
			var dragFlag = false;
			var x, y;

			div.onmousedown = function (e) {
				e = e || window.event;
				x = e.clientX - div.offsetLeft;
				y = e.clientY - div.offsetTop;
				dragFlag = true;
			};

			div.onmousemove = function (e) {
				if (dragFlag) {
					e = e || window.event;
					div.style.left = e.clientX - x + "px";
					div.style.top = e.clientY - y + "px";
				}
			};

			div.onmouseup = function (e) {
				dragFlag = false;
			};
		},


		changePage() {
			console.log(this.active)
			if (this.active == 0) {
				this.$router.push({
					path: '/mh5/index',
					query: {
						invitationCode: this.$route.query.invitationCode
					}
				})
			} else if (this.active == 1) {
				this.$router.push({
					path: '/mh5/personal',
					query: {
						invitationCode: this.$route.query.invitationCode
					}
				})
			}
		},



		getUserDetail() {
			if (JSON.parse(localStorage.getItem('userInfo'))) {
				api
					.getUserInfo({ userId: JSON.parse(localStorage.getItem('userInfo')).userId })
					.then(res => {
						if (res.code === 200) {
							console.log('重新获取一次帐号的信息', res.data)

							if (res.data.userId == 'ABH_Int') {
								res.data.partnerId = 28
							}
							if (res.data.partnerId) {
								this.checkPartner(true)
							}
							this.DELET_HAS_CLAIM_ALL(res.data)
							let data = res.data
							if (data.shopeeShops || data.lazadaShops || data.tiktokShops || data.temuAuth) {
								localStorage.setItem('shophasAuthorization', true)
							} else {
								localStorage.setItem('shophasAuthorization', false)
							}
							if (data.userPos === 'STORE') {
								localStorage.setItem('shophasAuthorization', true)
							}

							this.GET_LAZADA_SHOP(data.lazadaShops)
							localStorage.setItem('userInfo', JSON.stringify(data))
							localStorage.setItem('shopIdInfo', JSON.stringify(data.shopeeShops))
							localStorage.setItem('warehouse', JSON.stringify(data.stores))
							localStorage.setItem('lazadashopId', JSON.stringify(data.lazadaShops))
							localStorage.setItem('temuAuth', JSON.stringify(data.temuAuth))
						}
					})

			}
		},
		showChat() {
			this.showTrue = true

		},

		ttbv() {
			let ttp = this.hideAside.findIndex(p => p === this.$route.path)

			return !this.hideAside.some(p => p === this.$route.path)


		},
		async reload() {
			console.log('999');
			this.isRouterAlive = false
			await this.$nextTick(function () {
				this.isRouterAlive = true
			})
		},



	},



}
</script>


<style scope>
@import './assets/font/font.css';


@media only screen and (min-width:1280px) {
	html {
		font-size: 14px;
	}
}

@media only screen and (max-width:1280px) and (min-width:800px) {
	html {
		font-size: 14px;
	}
}

@media only screen and (max-width:800px) {
	html {
		font-size: 14px;
	}
}


.hokngdsklsdfg {
	font-size: 18px;
	/* font-family: "PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif; */
}


html {
	overflow-y: scroll;
	overflow-x: hidden
}

body {
	width: 100%;
	height: 100%;

	padding: 0;
	margin: 0;


}


.ser-div {
	position: absolute;
	top: 5px;
	right: 18px;
}

.service-body {
	width: 70px;
	height: 70px;
	background: #409eff;
	display: flex;
	color: #fff;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	position: fixed;
	top: 70%;
	right: 0%;
	z-index: 9999;
	cursor: pointer;
	border-radius: 50%;

}

.service-body:hover {
	background: #0066ff;
}

.main {
	display: flex;
	width: 100%;
}

.icon {
	width: 50px;
	height: 35px;
	vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
}

.icon01 {
	width: 125px;
	height: 36px;
	vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
}

.customerbox {
	position: fixed;
	right: 0;
	bottom: 200px;
	z-index: 9999;
	cursor: pointer;
}

.el-icon-service {
	font-size: 18px;
	color: #409eff;
}

.tipbf {

	flex: 1;
	margin: 55px 0 0 210px;
	transition: all 1s;
	position: relative;
}

.bkjm {
	flex: 1;
	margin: 0 !important;
	transition: all 1s;
	position: relative;
}

.kvbn {
	flex: 1;
	margin: 55px 0 0 75px;
	position: relative;
}

.el-image-viewer__prev {
	left: 20% !important;
}

.el-image-viewer__next {
	right: 20% !important;
}

.el-image-viewer__canvas {
	width: 60% !important;
	margin: 0 auto;
}

/* .el-image-viewer__canvas .el-image-viewer__img {
	max-width: 800px !important;
	max-height: 100% !important;
	height: auto !important;
} */
</style>